import { c as _c } from "react/compiler-runtime";
import React from "react";
import WebUnifiedWavesList from "./WebUnifiedWavesList";
import { useMyStream } from "../../../../contexts/wave/MyStreamContext";
interface WebBrainLeftSidebarWavesProps {
  readonly scrollContainerRef: React.RefObject<HTMLElement | null>;
  readonly isCollapsed?: boolean | undefined;
}
const WebBrainLeftSidebarWaves: React.FC<WebBrainLeftSidebarWavesProps> = t0 => {
  const $ = _c(11);
  const {
    scrollContainerRef,
    isCollapsed: t1
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  const {
    waves,
    registerWave
  } = useMyStream();
  let t2;
  if ($[0] !== waves) {
    t2 = () => {
      if (waves.hasNextPage && !waves.isFetchingNextPage && !waves.isFetching) {
        waves.fetchNextPage();
      }
    };
    $[0] = waves;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onNextPage = t2;
  let t3;
  if ($[2] !== isCollapsed || $[3] !== onNextPage || $[4] !== registerWave || $[5] !== scrollContainerRef || $[6] !== waves.hasNextPage || $[7] !== waves.isFetching || $[8] !== waves.isFetchingNextPage || $[9] !== waves.list) {
    t3 = <WebUnifiedWavesList waves={waves.list} fetchNextPage={onNextPage} hasNextPage={waves.hasNextPage} isFetching={waves.isFetching} isFetchingNextPage={waves.isFetchingNextPage} onHover={registerWave} scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} />;
    $[2] = isCollapsed;
    $[3] = onNextPage;
    $[4] = registerWave;
    $[5] = scrollContainerRef;
    $[6] = waves.hasNextPage;
    $[7] = waves.isFetching;
    $[8] = waves.isFetchingNextPage;
    $[9] = waves.list;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default WebBrainLeftSidebarWaves;